function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'mint': 'rgb(170, 255, 195)','lavender': 'rgb(230, 190, 255)','blue': 'rgb(28, 74, 236)','anthracite': 'rgb(65, 60, 66)','champagne': 'rgb(240, 221, 197)','coral': 'rgb(241, 113, 107)','smokyblue': 'rgb(118, 131, 162)','mint': 'rgb(172, 189, 179)','roseberyll': 'rgb(209, 176, 185)','turf': 'rgb(128, 71, 41)','schwarz': 'rgb(38, 35, 42)','olivia': 'rgb(106, 94, 66)','noords': 'rgb(85, 113, 119)','merlot': 'rgb(103, 32, 36)','salbei': 'rgb(127, 143, 111)','hellmeliert': 'rgb(166, 151, 152)','dunkelgrau': 'rgb(28, 25, 30)','bluete': 'rgb(232, 187, 182)','arctic': 'rgb(169, 213, 216)','weinrot': 'rgb(125, 1, 5)','minze': 'rgb(107, 198, 166)','mauve': 'rgb(88, 36, 70)','jeansblau': 'rgb(6, 97, 207)','melone': 'rgb(243, 152, 98)','kirschrot': 'rgb(183, 1, 4)','rot': 'rgb(183, 1, 4)','indigo': 'rgb(20, 47, 108)','petrol': 'rgb(0, 118, 145)','moos': 'rgb(85, 70, 54)','autumn': 'rgb(168, 39, 42)','beigemeliert': 'rgb(231, 212, 209)','urbangrau': 'rgb(169, 163, 163)','dunkelgruen': 'rgb(12, 47, 26)','bergblau': 'rgb(74, 77, 102)','magnolie': 'rgb(223, 185, 215)','limette': 'rgb(126, 154, 0)','piniengruen': 'rgb(38, 75, 83)','masala': 'rgb(142, 91, 10)','leuchtgelb': 'rgb(236, 187, 62)','blaubeere': 'rgb(20, 42, 91)','duene': 'rgb(171, 131, 96)','naturmeliert': 'rgb(133, 106, 95)','ozean': 'rgb(15, 56, 98)','mango': 'rgb(201, 57, 27)','lightgrey': 'rgb(169, 163, 163)','rose': 'rgb(209, 176, 185)','purple': 'rgb(102, 67, 90)','midnight': 'rgb(0, 38, 62)','trueffelbraun': 'rgb(70, 53, 51)','hellgrau': 'rgb(113, 107, 113)','beige': 'rgb(232, 221, 219)','anthrazit': 'rgb(64, 62, 76)','stahlblau': 'rgb(39, 78, 125)','beere': 'rgb(144, 20, 63)','gelb': 'rgb(250, 188, 101)','fuchsia': 'rgb(233, 7, 84)','rosa': 'rgb(228, 165, 162)','gletscher': 'rgb(125, 179, 209)','trueffel': 'rgb(70, 53, 51)','sand': 'rgb(206, 182, 144)','butterblume': 'rgb(255, 236, 157)','kiwi': 'rgb(174, 194, 99)',};

    this.images = {'set-1-weiss-kirschrot-20-stuck': 'url("//kontor28.de/cdn/shop/files/Set1_120x.png?v=18018367519644514705")','set-2-weiss-urbangrau-20-stuck': 'url("//kontor28.de/cdn/shop/files/Set2_120x.png?v=16419639072603070155")','set-3-weiss-naturmeliert-20-stuck': 'url("//kontor28.de/cdn/shop/files/Set3_120x.png?v=10634971861854282172")','set-1-gletscher-magnolie-16-stuck': 'url("//kontor28.de/cdn/shop/files/Set4_120x.png?v=4598139382663299770")','set-2-butterblume-salbei-16-stuck': 'url("//kontor28.de/cdn/shop/files/Set5_120x.png?v=16507228160958877748")','set-3-beige-sand-16-stuck': 'url("//kontor28.de/cdn/shop/files/Set6_120x.png?v=817657151661447791")',};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
